import i18next from 'i18next';

const timeSlotsMap = {
    'early-morning': {
        start: 6,
        end: 8,
    },
    morning: {
        start: 8,
        end: 10,
    },
    'late-morning': {
        start: 10,
        end: 12,
    },
    afternoon: {
        start: 12,
        end: 14,
    },
    'late-afternoon': {
        start: 14,
        end: 17,
    },
    evening: {
        start: 17,
        end: 20,
    },
};

function timeSlotDescriptionMap() {
    return {
        'early-morning': i18next.t('Early Morning (6am - 8am)'),
        morning: i18next.t('Morning (8am - 10am)'),
        'late-morning': i18next.t('Late Morning (10am - 12pm)'),
        afternoon: i18next.t('Afternoon (12pm - 2pm)'),
        'late-afternoon': i18next.t('Late Afternoon (2pm - 5pm)'),
        evening: i18next.t('Evening (5pm - 8pm)'),
    };
}

function timeSlotShortenedMap() {
    return {
        'early-morning': i18next.t('Early Morning'),
        morning: i18next.t('Morning'),
        'late-morning': i18next.t('Late Morning'),
        afternoon: i18next.t('Afternoon'),
        'late-afternoon': i18next.t('Late Afternoon'),
        evening: i18next.t('Evening'),
    };
}

export { timeSlotsMap, timeSlotDescriptionMap, timeSlotShortenedMap };
